<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="display-1 mb-3">Departments</h2>
    </v-flex>
    <v-flex xs12>
      <router-view></router-view>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'department'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/department/Department.vue